import {
  UsersListingMutations,
  UsersListingActions,
  UsersListingGetters
} from './users-listing-keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { usersListingService } from './users-listing.service';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    usersLoading: true,
    users: [],
    searchParam: '',
    usersRecordCount: 0,
    usersSortOrder: {
      sortBy: 'username',
      sortDirection: 'asc'
    },
    usersPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    usersActiveInactive: 'both'
  };
};

export const usersListingStore = {
  state: getInitialState(),

  getters: {
    [UsersListingGetters.UsersList]: state => state.users,
    [UsersListingGetters.SortBy]: state => state.usersSortOrder.sortBy,
    [UsersListingGetters.SortDirection]: state => state.usersSortOrder.sortDirection,
    [UsersListingGetters.UsersPerPage]: state => state.usersPaginationParameters.recordsPerPage,
    [UsersListingGetters.UsersListingOffset]: state => state.usersPaginationParameters.offset,
    [UsersListingGetters.UsersRecordCount]: state => state.usersRecordCount,
    [UsersListingGetters.UsersActiveInactive]: state => state.UsersActiveInactive
  },

  mutations: {
    [UsersListingMutations.SetUsersLoading](state, isLoading = true) {
      state.usersLoading = isLoading;
    },

    [UsersListingMutations.SetUsersList](state, users) {
      state.users = users;
    },
    [UsersListingMutations.SetUsersSortOrder](state, sortOrder) {
      state.usersSortOrder = sortOrder;
    },
    [UsersListingMutations.SetUsersPaginationParameters](state, pagination) {
      state.usersPaginationParameters = pagination;
    },
    [UsersListingMutations.ResetUsersPaginationOffset](state) {
      state.usersPaginationParameters.offset = 0;
    },
    [UsersListingMutations.SetUsersRecordCount](state, recordCount) {
      state.usersRecordCount = recordCount;
    },
    [UsersListingMutations.SetUsersActiveInactive](state, activeInactive) {
      state.UsersActiveInactive = activeInactive;
    },
    [UsersListingMutations.SetSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    },
    [UsersListingMutations.SetSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    }
  },

  actions: {
    [UsersListingActions.RetrieveUsers]({ state, commit, dispatch }) {
      commit(UsersListingMutations.SetUsersLoading);

      return usersListingService
        .retrieveUsers(
          state.UsersActiveInactive,
          state.usersSortOrder,
          state.usersPaginationParameters,
          state.searchParam
        )
        .then(users => {
          users.map(users => {
            users.name = users.last_name + ', ' + users.first_name;
          });
          dispatch(UsersListingActions.RetrieveUsersRecordCount);
          commit(UsersListingMutations.SetUsersList, users);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('users.listing.errors.retrieveUsers')
          });
          commit(UsersListingMutations.SetUsersLoading, false);
        });
    },
    [UsersListingActions.UsersSortOrder]({ commit, dispatch }, sortOrder) {
      commit(UsersListingMutations.SetUsersSortOrder, sortOrder);
      commit(UsersListingMutations.ResetUsersPaginationOffset);
      dispatch(UsersListingActions.RetrieveUsers);
    },
    [UsersListingActions.SetUsersPaginationParameters]({ commit, dispatch }, pagination) {
      commit(UsersListingMutations.SetUsersPaginationParameters, pagination);
      dispatch(UsersListingActions.RetrieveUsers);
    },
    [UsersListingActions.SetUsersActiveInactive]({ commit, dispatch }, activeInactive) {
      commit(UsersListingMutations.SetUsersActiveInactive, activeInactive);
      dispatch(UsersListingActions.RetrieveUsers);
    },

    [UsersListingActions.ExportThisPage]: function({ state }) {
      return usersListingService.downloadCurrentUsersXlsx(
        state.usersActiveInactive,
        state.usersSortOrder,
        state.usersPaginationParameters,
        state.searchParam
      );
    },

    [UsersListingActions.ExportAllUsers]: function({ state }) {
      return usersListingService.downloadAllUsersXlsx(
        state.usersActiveInactive,
        state.usersSortOrder,
        state.searchParam
      );
    },

    [UsersListingActions.RetrieveUsersRecordCount]: ({ state, commit, dispatch }) => {
      return usersListingService
        .retrieveRecordCount(state.UsersActiveInactive, state.searchParam)
        .then(res => {
          commit(UsersListingMutations.SetUsersRecordCount, res);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    },

    [UsersListingActions.UpddateSearchList]: ({ commit, dispatch }, searchList) => {
      commit(UsersListingMutations.SetSearchParam, searchList.searchParam);
      commit(UsersListingMutations.ResetUsersPaginationOffset);

      return dispatch(UsersListingActions.RetrieveUsersRecordCount).then(() => {
        commit(UsersListingMutations.SetUsersList, searchList.data);
      });

      /*return 
      if (searchList.isSearchKey) {
        commit(UsersListingMutations.ResetUsersPaginationOffset);
        commit(UsersListingMutations.SetUsersRecordCount, searchList.data.length);
        commit(UsersListingMutations.SetUsersList, searchList.data);
      } else {
        dispatch(UsersListingActions.RetrieveUsers);
      }*/
    }
  }
};
